import React from "react";
import { Step } from "../../../types/wizard";

interface RadioGroupProps {
  step: Step,
  onChange?: (selectedValue: string) => void; // Callback to handle changes
}

const RadioGroup: React.FC<RadioGroupProps> = ({ step, onChange }) => {
  const { title, selectedValue, options } = step;

  return (
    <>
      <div className="w-full mb-2">
        {title && <h4 className="font-bold text-lg my-4">{title}</h4>}

        {/* Disclaimer */}
        {step.disclaimer && (
          <div className="flex flex-row pb-4 w-full">
            <div
              dangerouslySetInnerHTML={{
                __html: step.disclaimer.message,
              }}
              className="list-disc pl-6"
            ></div>
          </div>
        )}

        {/* Radio options */}
        {options.map((option, index) => (
          <div className="radio-button" key={option.id}>
            <input
              type="radio"
              name={`${title?.toLowerCase().replace(/\s/g, "-")}-option`}
              id={`${option.id}`}
              value={option.name}
              defaultChecked={
                (selectedValue && selectedValue === option.name) ||
                (!selectedValue && index === 0)
              }
              onChange={() => onChange?.(option.name)}
            />
            <label htmlFor={`${option.id}`} className="form-check-label">
              {option.name}
            </label>
          </div>
        ))}
      </div>
      <hr className="dashed-title" />
    </>
  );
};

export default RadioGroup;
